import { environment as base } from './environment';
import { apiUrls } from './api-urls';
import type { Environment } from './environment';

export const environment: Environment = {
  ...base,
  apiProxyUrl: 'https://api-stg.uhg.com/api/pdr/msr/uhci-aws-core-api/v3.0.0/',
  ssoApiProxyUrl: 'https://uhcinsights-stage.uhc.com/',
  postLoginProxyUrl: 'https://api-stg.uhg.com/api/pdr/msr/uhci-aws-core-api/v3.0.0/',
  originUrl: '/',
  redirectUri: 'https://uhcinsights-stage.uhc.com/',
  ohidApiProxyUrl: 'https://uhcinsights-stage.uhc.com/',
  ohidredirectUri: 'https://uhcinsights-stage.uhc.com/login',
  externalEnvironment: 'https://uhcinsights-stage.uhc.com/login',
  goldCardApi: 'https://api-stg.uhg.com/api/pdr/msr/uhci-aws-goldcard-api/v3.0.0/',
  domain: '.uhc.com',
  domainEnvironment: ['https://uhcinsights-stage.uhc.com'],
  cookieEnvironment: '',
  featureFlagUrl: 'https://api-stg.uhg.com/api/pdr/msr/uhci-aws-pnb-api/v3.0.0/pnb/feature-flags/',
  upstreamEnv: 'stage',
  goldCardEnvironment: 'stage',
  goldCardabyssparcelUrl: 'https://uhcinsights-stage.uhc.com/abyss-parcel.js',
  qualtricksEnvCheck: 'stage',
  clickStreamUrl:
    'https://assets.adobedtm.com/512027f42d3c/c18a9fa8e51b/launch-EN8719bda8a40e4a799c546a079b0dbd92-staging.min.js',
  production: false,
  staging: true,
  internalAccess: false,
  internalSsoLogin: false,
  XSRFToggle: false,
  goldCardFeatureToggle: 'true',
  tinLevelExternalChange: true,
  apiUrls: {
    ...apiUrls,
    bulkTinRUrl: 'https://api-stg.uhg.com/api/pdr/msr/uhci-aws-bulk-process-api/v3.0.0/',
    SsoRedirectUri:
      'https://stage-sso.uhc.com/ext/as/authorization.oauth2?pfidpadapterid=OptumIdOIDCStage&client_id=PED42235&response_' +
      'type=code&redirect_uri=https://uhcinsights-stage.uhc.com/login&scope=openid+profile+email&state=PED&prompt=none',
    SsoRedirectUriWithOutPrompt:
      'https://identity.nonprod.onehealthcareid.com/oidc/authorize?client_id=PED42235&response_type=code' +
      '&redirect_uri=https://uhcinsights-stage.uhc.com/login&scope=openid+profile+email&state=PED',
    SsoRedirectLogin:
      'https://identity.nonprod.onehealthcareid.com/oidc/authorize?client_id=PED42235&response_type=code&' +
      'redirect_uri=https://uhcinsights-stage.uhc.com/login&scope=openid+profile+email&state=PED&prompt=login',
    SsoLogoutUrl:
      'https://identity.nonprod.onehealthcareid.com/oidc/logout?id_token_hint=id_token_hint_delimiter' +
      '&post_logout_redirect_uri=https://uhcinsights-stage.uhc.com/&state=logout',
    linkLoginPage: 'https://provider-stage.linkhealth.com',
    providerLoginPage: 'https://secure-nonprod.uhcprovider.com/stage/#/',
  },
};
